import ServiceItem from './ServiceItem';
import CustomHelmet from '../CustomHelmet';
import { BASE_TITLE } from '../Common';
import ServiceItems from '../ListGroups/ServiceItems';



const Index = () => {


    return (
        <>
            <CustomHelmet title={BASE_TITLE + "首頁"} />
            <ul className="cards">
                {
                    ServiceItems.map((el, index) => {
                        return <ServiceItem key={index} headerText={el.headerText} list={el.list} Imgsrc={el.Imgsrc} link={el.Link} anchorPosition={el.AnchorPosition}/>
                    })}
            </ul>
        </>


    );

}

export default Index;